// utils
import { fetcher, endpoints } from '../utils/axios';
/**
 * Retrieves the list of feedback for a specific job.
 * @param {Object} payload - The object containing query parameters for the request.
 *                           The required parameter is 'jobId'.
 * @return {Promise} A promise resolving to an object containing the list of feedback.
 */

export async function getFeedbackList(payload) {
    const URL = endpoints.feedback.getFeedbackList;
    return await fetcher([URL, { params: payload }])
}

/**
 * Retrieve feedback for a specific application.
 * @param {Object} payload - The object containing query parameters for the request.
 *                           The required parameter is 'jobId'.
 * @return {Promise} A promise resolving to an object containing the application feedback.
 */

export async function getApplicationFeedback(payload) {
    const URL = endpoints.feedback.getApplicationFeedback;
    return await fetcher([URL, { params: payload }])
}